/** Перенос `lib/src/config/app_colors.dart` — значения один в один. */
export const AppColors = {
  cE94040: '#E94040',
  c444D80: '#444D80',
  c005EFF: '#005EFF',
  cD75B5B: '#D75B5B',
  cD7B25B: '#D7B25B',
  c91D75B: '#91D75B',
  cC8C8C8: '#C8C8C8',
  c4E4E4E: '#4E4E4E',
} as const;

export type AppColor = (typeof AppColors)[keyof typeof AppColors];

/** `Colors.white.withValues(alpha: x)` */
export function whiteAlpha(alpha: number): string {
  return `rgba(255, 255, 255, ${alpha})`;
}

/** `Colors.black.withValues(alpha: x)` */
export function blackAlpha(alpha: number): string {
  return `rgba(0, 0, 0, ${alpha})`;
}
